import React, { Component } from 'react';
import { connect } from 'react-redux';
import { setVariantsQuantity } from '../../actions/orders';
import Select from '../../components/Common/Select';

class Index extends Component {
  onVariantsChange = this.onVariantsChange;

  onVariantsChange(id) {
    const { variants, setVariantsQuantity } = this.props;
    const currentVariant = variants.find(variant => variant.external_id === id);

    setVariantsQuantity(`${currentVariant.external_id}_quantity`, 1, {
      singleVariant: true,
    });
  }

  variantOptions() {
    const { variants, priceSymbol } = this.props;
    const price = id => variants.find(x => x.external_id === id).price;

    return variants.map(({ external_id, title }) => ({
      label: `${title} ${priceSymbol}${price(external_id)}`,
      value: external_id,
    }));
  }

  render() {
    const { variantSelected, className, style } = this.props;
    return (
      <Select
        placeholder="Select Variant ..."
        name="variants"
        style={style}
        className={className}
        value={variantSelected}
        options={this.variantOptions()}
        isClearable={false}
        isSearchable={false}
        onChange={x => this.onVariantsChange(x)}
      />
    );
  }
}

export default connect(
  ({ product, order }) => ({
    variants: product.data.variants,
    variantSelected: order.variantSelected,
  }),
  dispatch => ({
    setVariantsQuantity: (a, b, c) => dispatch(setVariantsQuantity(a, b, c)),
  }),
)(Index);
